import { Input } from '@/components/ui/input'
import Spinner from '@/components/ui/spinner'
import { formatCEP } from '@/utils/format'

type CEPInputProps = {
  value: string
  onChange: (value: string) => void
  loading?: boolean
}

export function CEPInput({ value, onChange, loading = false }: CEPInputProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const formatted = formatCEP(e.target.value)
    onChange(formatted)
  }

  return (
    <div className="flex items-center gap-2">
      <Input
        type="text"
        inputMode="numeric"
        pattern="\d{5}-\d{3}"
        placeholder="00000-000"
        value={value}
        onChange={handleChange}
        className="bg-input text-foreground"
      />
      {loading && <Spinner />}
    </div>
  )
}
